export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7357.f2d9be43.jpg";